import React, {useContext, useEffect, useState, useRef} from 'react';
import styles from '../../styles/dashboard.module.css';
import gpsStyles from './gps.module.css';
import Header from "../../components/header/header";
import PageTitle from "../../components/page_title/page_title";
import GPSTabs from "./components/gps_tabs";
import GoogleMapReact from 'google-map-react';
import axiosInstance from "../../AxiosInstance";
import MyContext from "../../Context";
import Modal from "../../components/modal/modal";
import {TextInput} from "../../components/input/inputs";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faTrash, faEdit, faPencil, faUpload, faClock, faPlus, faTimes} from "@fortawesome/free-solid-svg-icons";
import proj4 from 'proj4';
import PhoneInput from "react-phone-input-2";
import {PlaceholderTextarea, PlaceholderInput} from "../../components/input/PlaceholderTextarea";
import {useTranslation} from 'react-i18next';

const SCHEDULE_PLACEHOLDERS = ['{zone_name}', '{device_count}', '{device_list}', '{start_time}', '{end_time}', '{date}'];
const PRE_ALERT_PLACEHOLDERS = ['{device_id}', '{device_identifier}', '{device_name}', '{asset_name}', '{zone_name}', '{start_time}', '{end_time}'];

function polygonToWKT(polygon) {
    const path = polygon.getPath();
    const coords = [];
    for (let i = 0; i < path.getLength(); i++) {
        const point = path.getAt(i);
        coords.push(`${point.lng()} ${point.lat()}`);
    }
    coords.push(coords[0]); // Close polygon
    return `POLYGON((${coords.join(', ')}))`;
}

export default function GPSZones() {
        const [showDeleteScheduleConfirm, setShowDeleteScheduleConfirm] = useState(false);
    const {t} = useTranslation();
    const project_id = parseInt(localStorage.getItem('project_id'));
    const {corporateGroup} = useContext(MyContext);
    const [zones, setZones] = useState([]);
    const [mapApi, setMapApi] = useState(null);
    const [mapInstance, setMapInstance] = useState(null);
    const [drawingManager, setDrawingManager] = useState(null);
    const [isDrawing, setIsDrawing] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [editForm, setEditForm] = useState({name: '', max_overtime_minutes: 0});
    const [editingZone, setEditingZone] = useState(null);
    const [showCreateModal, setShowCreateModal] = useState(false);
    const [createForm, setCreateForm] = useState({name: '', max_overtime_minutes: 0});
    const [pendingWKT, setPendingWKT] = useState(null);
    const polygonsRef = useRef([]);

    // Upload file state
    const [showUploadModal, setShowUploadModal] = useState(false);
    const [uploadFile, setUploadFile] = useState(null);
    const [uploadRows, setUploadRows] = useState([]);
    const [uploadDelimiter, setUploadDelimiter] = useState('auto');
    const [uploadColX, setUploadColX] = useState(0);
    const [uploadColY, setUploadColY] = useState(1);
    const [uploadCoordSystem, setUploadCoordSystem] = useState('wgs84');
    const [uploadUtmZone, setUploadUtmZone] = useState(18);
    const [uploadUtmHemi, setUploadUtmHemi] = useState('S');
    const [uploadZoneName, setUploadZoneName] = useState('');
    const [uploadMaxOvertime, setUploadMaxOvertime] = useState(0);

    // Delete confirmation state
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [deleteZoneId, setDeleteZoneId] = useState(null);

    // Schedule state
    const [showScheduleModal, setShowScheduleModal] = useState(false);
    const [sosSaveConfirmPending, setSosSaveConfirmPending] = useState(false);
    const [scheduleError, setScheduleError] = useState(null);
    const [fieldErrors, setFieldErrors] = useState({});
    const [schedulingZone, setSchedulingZone] = useState(null);
    const [scheduleForm, setScheduleForm] = useState({
        schedule_type: 'once', start_time: '08:00', end_time: '17:00',
        specific_date: '', days_of_week: '0,1,2,3,4',
        pre_alert_enabled: false,
        pre_alert_minutes: 15, pre_alert_action_type: 5,
        pre_alert_mqtt_connection: '', pre_alert_api_connection: '',
        pre_alert_topic_or_endpoint: 'alerts/prealert/{device_id}',
        pre_alert_payload: '{"device_id":"{device_id}","zone":"{zone_name}","starts":"{start_time}"}',
        pre_alert_http_method: 'POST',
        pre_alert_use_sos: false,
        entry_notification_sos: false,
    });
    const [sosCoverage, setSosCoverage] = useState(null);
    const [scheduleTargets, setScheduleTargets] = useState({type: 'individuals', individual_ids: [], group_ids: []});
    const [notificationConfig, setNotificationConfig] = useState({
        method_1: 1, destination_1: '', subject_1: '', message_1: '',
        method_2: null, destination_2: '', subject_2: '', message_2: '',
        mqtt_connection: null, api_connection: null,
        emails_1: [], emails_2: [],
    });
    const [emailInput1, setEmailInput1] = useState('');
    const [emailInput2, setEmailInput2] = useState('');
    const [assets, setAssets] = useState([]);
    const [groups, setGroups] = useState([]);
    const [mqttConnections, setMqttConnections] = useState([]);
    const [apiConnections, setApiConnections] = useState([]);

    const mapCenter = {
        lat: corporateGroup?.gps_map_center_lat || 14.72,
        lng: corporateGroup?.gps_map_center_lng || -75.12
    };
    const mapZoom = corporateGroup?.gps_map_zoom || 15;

    // fetchZones ahora retorna la promesa para poder encadenar acciones tras actualizar zonas
    const fetchZones = () => {
        if (!project_id) return Promise.resolve();
        return axiosInstance.get(`map_zone/?project_id=${project_id}`).then(res => setZones(res.data));
    };

    useEffect(() => {
        if (!project_id) return;
        let isMounted = true;
        axiosInstance.get(`map_zone/?project_id=${project_id}`).then(res => { if (isMounted) setZones(res.data); });
        return () => { isMounted = false; };
    }, [project_id]);

    // Draw existing zones on map
    useEffect(() => {
        if (!mapApi || !mapInstance) return;

        // Clear existing polygons
        polygonsRef.current.forEach(p => p.setMap(null));
        polygonsRef.current = [];

        zones.forEach(zone => {
            if (!zone.geometry) return;
            try {
                const coordStr = zone.geometry.replace('POLYGON((', '').replace('))', '');
                const coords = coordStr.split(',').map(pair => {
                    const [lng, lat] = pair.trim().split(' ').map(Number);
                    return {lat, lng};
                });

                const hasSchedule = !!zone.schedule;
                const zoneColor = hasSchedule ? '#7C3AED' : '#3B82F6';
                const polygon = new mapApi.Polygon({
                    paths: coords,
                    map: mapInstance,
                    strokeColor: zoneColor,
                    strokeOpacity: 0.8,
                    strokeWeight: hasSchedule ? 3 : 2,
                    fillColor: zoneColor,
                    fillOpacity: hasSchedule ? 0.25 : 0.2,
                });

                // Add info window on click
                mapApi.event.addListener(polygon, 'click', () => {
                    const infoWindow = new mapApi.InfoWindow({
                        content: `<div style="font-weight:600">${zone.name}</div>
                                  <div style="font-size:12px;color:#64748B">${zone.max_overtime_minutes ? t('gps.zones.maxOvertime', {minutes: zone.max_overtime_minutes}) : t('gps.zones.noLimit')}</div>`,
                        position: coords[0],
                    });
                    infoWindow.open(mapInstance);
                });

                polygonsRef.current.push(polygon);
            } catch (e) {
                console.error('Error drawing zone:', e);
            }
        });
    }, [mapApi, mapInstance, zones]);

    const handleApiLoaded = ({map, maps}) => {
        setMapApi(maps);
        setMapInstance(map);
    };

    const startDrawing = () => {
        if (!mapApi || !mapInstance) return;

        const dm = new mapApi.drawing.DrawingManager({
            drawingMode: mapApi.drawing.OverlayType.POLYGON,
            drawingControl: false,
            polygonOptions: {
                strokeColor: '#10B981',
                strokeOpacity: 0.8,
                strokeWeight: 2,
                fillColor: '#10B981',
                fillOpacity: 0.3,
                editable: true,
            },
        });

        dm.setMap(mapInstance);
        setDrawingManager(dm);
        setIsDrawing(true);

        mapApi.event.addListener(dm, 'polygoncomplete', (polygon) => {
            const wkt = polygonToWKT(polygon);

            dm.setMap(null);
            setDrawingManager(null);
            setIsDrawing(false);
            polygon.setMap(null);

            setPendingWKT(wkt);
            setCreateForm({name: '', max_overtime_minutes: 0});
            setShowCreateModal(true);
        });
    };

    const cancelDrawing = () => {
        if (drawingManager) drawingManager.setMap(null);
        setDrawingManager(null);
        setIsDrawing(false);
    };

    const editZone = (zone) => {
        setEditingZone(zone);
        setEditForm({name: zone.name, max_overtime_minutes: zone.max_overtime_minutes || 0});
        setShowEditModal(true);
    };

    const saveZoneEdit = () => {
        axiosInstance.put(`map_zone/${editingZone.id}/`, {
            ...editingZone,
            name: editForm.name,
            max_overtime_minutes: parseInt(editForm.max_overtime_minutes) || 0
        }).then(() => {
            setShowEditModal(false);
            fetchZones();
        });
    };

    const saveNewZone = () => {
        if (!createForm.name || !pendingWKT) return;
        axiosInstance.post('map_zone/', {
            name: createForm.name,
            geometry: pendingWKT,
            project: project_id,
            max_overtime_minutes: parseInt(createForm.max_overtime_minutes) || 0
        }).then(() => {
            setShowCreateModal(false);
            setPendingWKT(null);
            fetchZones();
        });
    };

    const deleteZone = (zoneId) => {
        setDeleteZoneId(zoneId);
        setShowDeleteModal(true);
    };

    const confirmDeleteZone = () => {
        axiosInstance.delete(`map_zone/${deleteZoneId}/`).then(fetchZones);
        setShowDeleteModal(false);
        setDeleteZoneId(null);
    };

    // --- Upload file logic ---
    const detectDelimiter = (line) => {
        if (line.includes('\t')) return '\t';
        if (line.includes(';')) return ';';
        if (line.includes(',')) return ',';
        return /\s+/; // whitespace (spaces)
    };

    const parseFileContent = (text, delim) => {
        const lines = text.trim().split('\n').filter(l => l.trim());
        const delimiter = delim === 'auto' ? detectDelimiter(lines[0]) :
            delim === 'tab' ? '\t' : delim === 'space' ? /\s+/ : delim;
        return lines.map(line => line.trim().split(delimiter).map(v => v.trim()));
    };

    const handleFileSelect = (e) => {
        const file = e.target.files[0];
        if (!file) return;
        setUploadFile(file);
        setUploadZoneName(file.name.replace(/\.[^/.]+$/, ''));
        const reader = new FileReader();
        reader.onload = (ev) => {
            const rows = parseFileContent(ev.target.result, uploadDelimiter);
            setUploadRows(rows);
            // Auto-detect columns: if first row has numbers, assume col0=X col1=Y
            if (rows.length > 0) {
                setUploadColX(0);
                setUploadColY(1);
            }
        };
        reader.readAsText(file);
    };

    const reparseFile = (delim) => {
        setUploadDelimiter(delim);
        if (!uploadFile) return;
        const reader = new FileReader();
        reader.onload = (ev) => {
            setUploadRows(parseFileContent(ev.target.result, delim));
        };
        reader.readAsText(uploadFile);
    };

    const saveUploadedZone = () => {
        if (!uploadZoneName || uploadRows.length < 3) return;

        const coords = uploadRows.map(row => {
            const x = parseFloat(row[uploadColX]);
            const y = parseFloat(row[uploadColY]);
            if (isNaN(x) || isNaN(y)) return null;

            if (uploadCoordSystem === 'utm') {
                const utmProj = `+proj=utm +zone=${uploadUtmZone} ${uploadUtmHemi === 'S' ? '+south' : ''} +datum=WGS84`;
                const [lng, lat] = proj4(utmProj, 'EPSG:4326', [x, y]);
                return {lng, lat};
            }
            // WGS84: user picks which is lat and which is lng
            return {lat: y, lng: x};
        }).filter(Boolean);

        if (coords.length < 3) return alert(t('gps.zones.minPoints'));

        // Close polygon
        const first = coords[0];
        const last = coords[coords.length - 1];
        if (first.lng !== last.lng || first.lat !== last.lat) {
            coords.push({...first});
        }

        const wkt = `POLYGON((${coords.map(c => `${c.lng} ${c.lat}`).join(', ')}))`;

        axiosInstance.post('map_zone/', {
            name: uploadZoneName,
            geometry: wkt,
            project: project_id,
            max_overtime_minutes: parseInt(uploadMaxOvertime) || 0
        }).then(() => {
            setShowUploadModal(false);
            setUploadFile(null);
            setUploadRows([]);
            fetchZones();
        });
    };

    const resetUploadModal = () => {
        setShowUploadModal(true);
        setUploadFile(null);
        setUploadRows([]);
        setUploadDelimiter('auto');
        setUploadColX(0);
        setUploadColY(1);
        setUploadCoordSystem('wgs84');
        setUploadUtmZone(18);
        setUploadUtmHemi('S');
        setUploadZoneName('');
        setUploadMaxOvertime(0);
    };

    // --- Schedule logic ---
    const fetchScheduleData = () => {
        if (!project_id) return;
        axiosInstance.get(`gps_asset/?project_id=${project_id}`).then(res => setAssets(res.data)).catch(() => {});
        axiosInstance.get(`gps_asset_group/?project_id=${project_id}`).then(res => setGroups(res.data)).catch(() => {});
        axiosInstance.get(`mqtt_connection/?project_id=${project_id}`).then(res => setMqttConnections(Array.isArray(res.data) ? res.data : (res.data.results || []))).catch(() => {});
        axiosInstance.get(`api_connection/?project_id=${project_id}`).then(res => setApiConnections(Array.isArray(res.data) ? res.data : (res.data.results || []))).catch(() => {});
    };

    const fetchSosCoverage = (zone, targets) => {
        let params = `zone_id=${zone.id}`;
        if (targets) {
            if (targets.type === 'individuals') {
                targets.individual_ids.forEach(id => { params += `&individual_ids=${id}`; });
            } else {
                targets.group_ids.forEach(id => { params += `&group_ids=${id}`; });
            }
        }
        axiosInstance.get(`zone_schedule/validate_sos/?${params}`)
            .then(res => setSosCoverage(res.data))
            .catch(() => setSosCoverage(null));
    };

    const openScheduleModal = (zone) => {
        setSchedulingZone(zone);
        fetchScheduleData();

        let initialForm, useSos, entryNotiSos;
        if (zone.schedule) {
            const s = zone.schedule;
            useSos = !!(s.pre_alert_use_sos);
            entryNotiSos = !!(s.entry_notification_sos);
            initialForm = {
                schedule_type: s.schedule_type || 'once',
                start_time: s.start_time?.substring(0, 5) || '08:00',
                end_time: s.end_time?.substring(0, 5) || '17:00',
                specific_date: s.specific_date || '',
                days_of_week: s.days_of_week || '0,1,2,3,4',
                pre_alert_enabled: !!(s.pre_alert_topic_or_endpoint) || useSos,
                pre_alert_minutes: s.pre_alert_minutes || 15,
                pre_alert_action_type: s.pre_alert_action_type || 5,
                pre_alert_mqtt_connection: s.pre_alert_mqtt_connection || '',
                pre_alert_api_connection: s.pre_alert_api_connection || '',
                pre_alert_topic_or_endpoint: s.pre_alert_topic_or_endpoint || '',
                pre_alert_payload: s.pre_alert_payload || '',
                pre_alert_http_method: s.pre_alert_http_method || 'POST',
                pre_alert_use_sos: useSos,
                entry_notification_sos: entryNotiSos,
            };
        } else {
            initialForm = {
                schedule_type: 'once', start_time: '08:00', end_time: '17:00',
                specific_date: '', days_of_week: '0,1,2,3,4',
                pre_alert_enabled: false,
                pre_alert_minutes: 15, pre_alert_action_type: 5,
                pre_alert_mqtt_connection: '', pre_alert_api_connection: '',
                pre_alert_topic_or_endpoint: 'alerts/prealert/{device_id}',
                pre_alert_payload: '{"device_id":"{device_id}","zone":"{zone_name}","starts":"{start_time}"}',
                pre_alert_http_method: 'POST',
                pre_alert_use_sos: false,
                entry_notification_sos: false,
            };
        }
        setScheduleForm(initialForm);
        setEmailInput1('');
        setEmailInput2('');
        // reconstruir targets y notificaciones si existe schedule
        if (zone.schedule) {
            const s = zone.schedule;
            const indivIds = s.targets?.filter(t => t.device_user).map(t => t.device_user) || [];
            const grpIds = s.targets?.filter(t => t.asset_group).map(t => t.asset_group) || [];
            setScheduleTargets({
                type: indivIds.length > 0 ? 'individuals' : 'groups',
                individual_ids: indivIds, group_ids: grpIds,
            });
            const contact = (s.contacts || [])[0] || {};
            setNotificationConfig({
                method_1: contact.method_1 || 1,
                destination_1: contact.destination_1 || '',
                subject_1: contact.subject_1 || '',
                message_1: contact.message_1 || '',
                method_2: contact.method_2 || null,
                destination_2: contact.destination_2 || '',
                subject_2: contact.subject_2 || '',
                message_2: contact.message_2 || '',
                mqtt_connection: contact.mqtt_connection || null,
                api_connection: contact.api_connection || null,
                emails_1: contact.method_1 === 1 && contact.destination_1 ? contact.destination_1.split(',').map(e => e.trim()).filter(Boolean) : [],
                emails_2: contact.method_2 === 1 && contact.destination_2 ? contact.destination_2.split(',').map(e => e.trim()).filter(Boolean) : [],
            });
        } else {
            setSosCoverage(null);
            setScheduleTargets({type: 'individuals', individual_ids: [], group_ids: []});
            setNotificationConfig({
                method_1: 1, destination_1: '', subject_1: '', message_1: '',
                method_2: null, destination_2: '', subject_2: '', message_2: '',
                mqtt_connection: null, api_connection: null, emails_1: [], emails_2: [],
            });
        }
        setShowScheduleModal(true);
        // Validar cobertura SOS al abrir modal si corresponde
        const shouldCheckSos = (zone.schedule && (useSos || entryNotiSos)) || (!zone.schedule && (initialForm.pre_alert_use_sos || initialForm.entry_notification_sos));
        if (shouldCheckSos) fetchSosCoverage(zone);
    };

    const saveSchedule = async (skipSosCheck = false) => {
        // Siempre verificar cobertura SOS al guardar, independiente del action type
        let sosError = false;
        if (!skipSosCheck) {
            // Siempre fetchear con los targets actuales (no usar cache de sosCoverage)
            let coverage = null;
            try {
                let params = `zone_id=${schedulingZone.id}`;
                if (scheduleTargets.type === 'individuals') {
                    scheduleTargets.individual_ids.forEach(id => { params += `&individual_ids=${id}`; });
                } else {
                    scheduleTargets.group_ids.forEach(id => { params += `&group_ids=${id}`; });
                }
                const res = await axiosInstance.get(`zone_schedule/validate_sos/?${params}`);
                setSosCoverage(res.data);
                coverage = res.data;
            } catch {
                setScheduleError(t('gps.zones.schedule.sosAllMissingError'));
                sosError = true;
            }
            if (!sosError && coverage && coverage.missing?.length > 0) {
                if ((coverage.covered?.length || 0) === 0) {
                    // Ningún device_type tiene SOS → bloquear
                    setScheduleError(t('gps.zones.schedule.sosAllMissingError'));
                    sosError = true;
                } else {
                    // Algunos faltan → pedir confirmación pero permitir si confirman
                    setSosSaveConfirmPending(true);
                    sosError = true;
                }
            }
        }
        if (sosError) return; // No cerrar el modal de schedule si hay error
        setSosSaveConfirmPending(false);
        setFieldErrors({});

        // Validate destination for method 1 (not required if entry_notification_sos is the only notification)
        const dest1 = notificationConfig.method_1 === 1
            ? notificationConfig.emails_1.join(',')
            : notificationConfig.destination_1;
        if (!dest1 && !scheduleForm.entry_notification_sos) {
            setScheduleError(t('gps.zones.schedule.configureDestination'));
            return;
        }

        const targetArr = scheduleTargets.type === 'individuals'
            ? scheduleTargets.individual_ids.map(id => ({device_user: id, asset_group: null}))
            : scheduleTargets.group_ids.map(id => ({device_user: null, asset_group: id}));
        if (targetArr.length === 0) {
            setScheduleError(t('gps.zones.schedule.selectTarget'));
            return;
        }

        const dest2 = notificationConfig.method_2 === 1
            ? notificationConfig.emails_2.join(',')
            : notificationConfig.destination_2;

        const nc = notificationConfig;
        const preAlertSos = scheduleForm.pre_alert_enabled && scheduleForm.pre_alert_use_sos;
        const payload = {
            zone: schedulingZone.id,
            ...scheduleForm,
            specific_date: scheduleForm.specific_date || null,
            pre_alert_minutes: scheduleForm.pre_alert_enabled ? scheduleForm.pre_alert_minutes : 0,
            pre_alert_action_type: scheduleForm.pre_alert_action_type,
            pre_alert_use_sos: preAlertSos,
            pre_alert_mqtt_connection: scheduleForm.pre_alert_enabled && !preAlertSos && scheduleForm.pre_alert_action_type === 5 ? (scheduleForm.pre_alert_mqtt_connection || null) : null,
            pre_alert_api_connection: scheduleForm.pre_alert_enabled && !preAlertSos && scheduleForm.pre_alert_action_type === 6 ? (scheduleForm.pre_alert_api_connection || null) : null,
            pre_alert_topic_or_endpoint: scheduleForm.pre_alert_enabled && !preAlertSos ? scheduleForm.pre_alert_topic_or_endpoint : '',
            pre_alert_payload: scheduleForm.pre_alert_enabled && !preAlertSos ? scheduleForm.pre_alert_payload : '',
            entry_notification_sos: scheduleForm.entry_notification_sos,
            targets: targetArr,
            contacts: dest1 ? [{
                name: '',
                method_1: nc.method_1,
                destination_1: dest1,
                subject_1: nc.subject_1 || '',
                message_1: nc.message_1 || '',
                method_2: nc.method_2 || null,
                destination_2: nc.method_2 ? dest2 : '',
                subject_2: nc.subject_2 || '',
                message_2: nc.message_2 || '',
                mqtt_connection: [nc.method_1, nc.method_2].includes(5) ? (nc.mqtt_connection || null) : null,
                api_connection: [nc.method_1, nc.method_2].includes(6) ? (nc.api_connection || null) : null,
            }] : [],
        };

        const existing = schedulingZone.schedule;
        const req = existing
            ? axiosInstance.put(`zone_schedule/${existing.id}/`, payload)
            : axiosInstance.post('zone_schedule/', payload);

        req.then(() => {
            // Tras guardar, recargar zonas y sincronizar la zona seleccionada si el modal sigue abierto
            fetchZones(true).then((res) => {
                setShowScheduleModal(false);
                setSchedulingZone(null);
            });
        }).catch(err => {
            if (err.response?.status === 400 && err.response?.data) {
                const { non_field_errors, ...rest } = err.response.data;
                setFieldErrors(rest);
                // Si hay error de SOS, mostrarlo traducido
                if (non_field_errors?.length) {
                    let msg = non_field_errors[0];
                    if (msg.toLowerCase().includes('sos')) {
                        msg = t('gps.zones.schedule.sosAllMissingError');
                    } else if (msg.toLowerCase().includes('destination')) {
                        msg = t('gps.zones.schedule.configureDestination');
                    } else if (msg.toLowerCase().includes('target')) {
                        msg = t('gps.zones.schedule.selectTarget');
                    } else if (msg.toLowerCase().includes('save')) {
                        msg = t('gps.zones.schedule.saveError');
                    }
                    setScheduleError(msg);
                }
            } else {
                setScheduleError(t('gps.zones.schedule.saveError') || 'Error al guardar');
            }
        });
    };

    const deleteSchedule = () => {
        if (!schedulingZone?.schedule) return;
        setShowDeleteScheduleConfirm(true);
    };

    const confirmDeleteSchedule = () => {
        // Validar que el schedule existe y tiene ID válido
        if (!schedulingZone?.schedule || !schedulingZone.schedule.id) {
            setShowDeleteScheduleConfirm(false);
            return;
        }
        axiosInstance.delete(`zone_schedule/${schedulingZone.schedule.id}/`).then(() => {
            // Tras borrar, recargar zonas y limpiar zona seleccionada
            fetchZones(true).then(() => {
                setShowScheduleModal(false);
                setShowDeleteScheduleConfirm(false);
                setSchedulingZone(null);
            });
        }).catch((err) => {
            // Si ya fue borrado, limpiar estado y cerrar modales
            if (err.response?.status === 404) {
                fetchZones(true).then(() => {
                    setShowScheduleModal(false);
                    setShowDeleteScheduleConfirm(false);
                    setSchedulingZone(null);
                });
            }
        });
    };

    const toggleTargetId = (id, field) => {
        setSosCoverage(null); // reset para re-fetch en el próximo save
        setScheduleTargets(prev => {
            const arr = [...prev[field]];
            const idx = arr.indexOf(id);
            if (idx >= 0) arr.splice(idx, 1); else arr.push(id);
            return {...prev, [field]: arr};
        });
    };

    const updateNotification = (field, value) => {
        setNotificationConfig(prev => {
            const updated = {...prev, [field]: value};
            // If method_1 changes and method_2 is the same, reset method_2
            if (field === 'method_1' && prev.method_2 === value) {
                updated.method_2 = null;
                updated.destination_2 = '';
                updated.subject_2 = '';
                updated.message_2 = '';
                updated.emails_2 = [];
            }
            // Clear fields when method changes
            if (field === 'method_1') {
                updated.destination_1 = '';
                updated.subject_1 = '';
                updated.message_1 = '';
                updated.emails_1 = [];
            }
            if (field === 'method_2') {
                updated.destination_2 = '';
                updated.subject_2 = '';
                updated.message_2 = '';
                updated.emails_2 = [];
            }
            return updated;
        });
    };

    const addEmail = (slot, email) => {
        const trimmed = email.trim().toLowerCase();
        if (!trimmed || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmed)) return;
        const key = `emails_${slot}`;
        setNotificationConfig(prev => {
            if (prev[key].includes(trimmed)) return prev;
            return {...prev, [key]: [...prev[key], trimmed]};
        });
    };

    const removeEmail = (slot, index) => {
        const key = `emails_${slot}`;
        setNotificationConfig(prev => ({...prev, [key]: prev[key].filter((_, i) => i !== index)}));
    };

    const NOTIFICATION_METHODS = [{id: 1, name: 'Email'}, {id: 3, name: 'SMS'}, {id: 4, name: 'WhatsApp'}, {id: 5, name: 'MQTT'}, {id: 6, name: 'API'}];

    const renderMethodFields = (slot) => {
        const method = notificationConfig[`method_${slot}`];
        if (!method) return null;

        const inputStyle = {width: '100%', padding: '6px', borderRadius: '4px', border: '1px solid #CBD5E1', fontSize: '12px'};
        const labelStyle = {fontSize: '11px', color: '#64748B', marginTop: '6px', marginBottom: '2px'};

        if (method === 1) {
            // Email — chips + subject + body
            const emails = notificationConfig[`emails_${slot}`];
            const inputVal = slot === 1 ? emailInput1 : emailInput2;
            const setInputVal = slot === 1 ? setEmailInput1 : setEmailInput2;
            return (
                <div style={{marginTop: '6px'}}>
                    <div style={labelStyle}>{t('gps.zones.notification.emailAddresses')}</div>
                    <div style={{
                        border: '1px solid #CBD5E1', borderRadius: '4px', padding: '4px',
                        display: 'flex', flexWrap: 'wrap', gap: '4px', alignItems: 'center', minHeight: '32px',
                    }}>
                        {emails.map((email, i) => (
                            <span key={i} style={{
                                backgroundColor: '#EDE9FE', color: '#5B21B6', fontSize: '11px',
                                padding: '2px 6px', borderRadius: '10px', display: 'flex', alignItems: 'center', gap: '4px',
                            }}>
                                {email}
                                <span style={{cursor: 'pointer', fontWeight: 'bold'}} onClick={() => removeEmail(slot, i)}>&times;</span>
                            </span>
                        ))}
                        <input
                            type="email" value={inputVal} placeholder={t('gps.zones.notification.typeEmail')}
                            onChange={e => setInputVal(e.target.value)}
                            onKeyDown={e => {
                                if (e.key === 'Enter') {
                                    e.preventDefault();
                                    addEmail(slot, inputVal);
                                    setInputVal('');
                                }
                            }}
                            style={{border: 'none', outline: 'none', fontSize: '12px', flex: 1, minWidth: '140px', padding: '2px'}}
                        />
                    </div>
                    <div style={labelStyle}>{t('gps.zones.notification.subject')}</div>
                    <PlaceholderInput
                        value={notificationConfig[`subject_${slot}`]}
                        placeholder="Zone Alert: {device_count} device(s) entered {zone_name}"
                        onChange={v => setNotificationConfig(prev => ({...prev, [`subject_${slot}`]: v}))}
                        style={inputStyle}
                        placeholders={SCHEDULE_PLACEHOLDERS}
                    />
                    <div style={labelStyle}>{t('gps.zones.notification.body')}</div>
                    <PlaceholderTextarea
                        value={notificationConfig[`message_${slot}`]}
                        placeholder="Devices: {device_list} entered zone {zone_name} ({start_time} - {end_time})"
                        onChange={v => setNotificationConfig(prev => ({...prev, [`message_${slot}`]: v}))}
                        style={{...inputStyle, minHeight: '50px'}}
                        placeholders={SCHEDULE_PLACEHOLDERS}
                    />
                </div>
            );
        }

        if (method === 3 || method === 4) {
            // SMS or WhatsApp — phone input with flags + message
            const dest = notificationConfig[`destination_${slot}`] || '';
            // PhoneInput stores without '+', backend stores with '+'
            const phoneValue = dest.startsWith('+') ? dest.substring(1) : dest;
            return (
                <div style={{marginTop: '6px'}}>
                    <div style={labelStyle}>{method === 3 ? t('gps.zones.notification.phoneSms') : t('gps.zones.notification.phoneWhatsapp')}</div>
                    <PhoneInput
                        country={'sn'}
                        value={phoneValue}
                        onChange={phone => setNotificationConfig(prev => ({...prev, [`destination_${slot}`]: '+' + phone}))}
                    />
                    <div style={labelStyle}>{t('gps.zones.notification.message')}</div>
                    <PlaceholderTextarea
                        value={notificationConfig[`message_${slot}`]}
                        placeholder="{device_count} device(s) entered {zone_name}: {device_list}"
                        onChange={v => setNotificationConfig(prev => ({...prev, [`message_${slot}`]: v}))}
                        style={{...inputStyle, minHeight: '50px'}}
                        placeholders={SCHEDULE_PLACEHOLDERS}
                    />
                </div>
            );
        }

        if (method === 5) {
            // MQTT — connection + topic + payload
            return (
                <div style={{marginTop: '6px'}}>
                    <div style={labelStyle}>{t('gps.zones.notification.mqttConnection')}</div>
                    <div className="d-flex align-items-center gap-2">
                        <select
                            value={notificationConfig.mqtt_connection || ''}
                            onChange={e => setNotificationConfig(prev => ({...prev, mqtt_connection: e.target.value ? parseInt(e.target.value) : null}))}
                            style={{...inputStyle, flex: 1}}>
                            <option value="">{t('gps.zones.notification.selectConnection')}</option>
                            {mqttConnections.map(c => <option key={c.id} value={c.id}>{c.name || c.broker}</option>)}
                        </select>
                        <a href="/connections" target="_blank" style={{fontSize: '11px', color: '#7C3AED', whiteSpace: 'nowrap'}}>{t('gps.zones.notification.manage')}</a>
                    </div>
                    <div style={labelStyle}>{t('gps.zones.notification.topic')}</div>
                    <PlaceholderInput
                        value={notificationConfig[`destination_${slot}`]}
                        placeholder="alerts/zone-entry"
                        onChange={v => setNotificationConfig(prev => ({...prev, [`destination_${slot}`]: v}))}
                        style={inputStyle}
                        placeholders={SCHEDULE_PLACEHOLDERS}
                    />
                    <div style={labelStyle}>{t('gps.zones.notification.payloadJson')}</div>
                    <PlaceholderTextarea
                        value={notificationConfig[`message_${slot}`]}
                        placeholder={'{"zone":"{zone_name}","devices":"{device_list}","count":"{device_count}"}'}
                        onChange={v => setNotificationConfig(prev => ({...prev, [`message_${slot}`]: v}))}
                        style={{...inputStyle, minHeight: '50px', fontFamily: 'monospace'}}
                        placeholders={SCHEDULE_PLACEHOLDERS}
                    />
                </div>
            );
        }

        if (method === 6) {
            // API — connection + endpoint + body
            return (
                <div style={{marginTop: '6px'}}>
                    <div style={labelStyle}>{t('gps.zones.notification.apiConnection')}</div>
                    <div className="d-flex align-items-center gap-2">
                        <select
                            value={notificationConfig.api_connection || ''}
                            onChange={e => setNotificationConfig(prev => ({...prev, api_connection: e.target.value ? parseInt(e.target.value) : null}))}
                            style={{...inputStyle, flex: 1}}>
                            <option value="">{t('gps.zones.notification.selectConnection')}</option>
                            {apiConnections.map(c => <option key={c.id} value={c.id}>{c.name || c.base_url}</option>)}
                        </select>
                        <a href="/connections" target="_blank" style={{fontSize: '11px', color: '#7C3AED', whiteSpace: 'nowrap'}}>{t('gps.zones.notification.manage')}</a>
                    </div>
                    <div style={labelStyle}>{t('gps.zones.notification.endpointPath')}</div>
                    <PlaceholderInput
                        value={notificationConfig[`destination_${slot}`]}
                        placeholder="/webhook/zone-entry"
                        onChange={v => setNotificationConfig(prev => ({...prev, [`destination_${slot}`]: v}))}
                        style={inputStyle}
                        placeholders={SCHEDULE_PLACEHOLDERS}
                    />
                    <div style={labelStyle}>{t('gps.zones.notification.bodyJson')}</div>
                    <PlaceholderTextarea
                        value={notificationConfig[`message_${slot}`]}
                        placeholder={'{"zone":"{zone_name}","devices":"{device_list}","count":"{device_count}"}'}
                        onChange={v => setNotificationConfig(prev => ({...prev, [`message_${slot}`]: v}))}
                        style={{...inputStyle, minHeight: '50px', fontFamily: 'monospace'}}
                        placeholders={SCHEDULE_PLACEHOLDERS}
                    />
                </div>
            );
        }

        return null;
    };
    const DAYS = t('gps.zones.schedule.dayNames', {returnObjects: true});

    const renderFieldError = (field) => {
        const err = fieldErrors[field];
        if (!err) return null;
        const msg = Array.isArray(err) ? err[0] : err;
        return <div style={{color: '#EF4444', fontSize: '11px', marginTop: '3px'}}>{msg}</div>;
    };

    return (
        <div className={styles.dashboard_container}>
            <Header sidebarIndex={1}/>

            <Modal show={showDeleteModal} setter={setShowDeleteModal} name={t('gps.zones.deleteZone')} buttonName={t('common.delete')} onClick={confirmDeleteZone}>
                <div style={{fontSize: '14px', color: '#334155'}}>
                    {t('gps.zones.deleteZoneConfirm')}
                </div>
            </Modal>

            <Modal show={showCreateModal} setter={setShowCreateModal} name={t('gps.zones.createZone')} buttonName={t('common.create')} onClick={saveNewZone}>
                <TextInput form={createForm} setForm={setCreateForm} name={'name'} placeholder={t('gps.zones.zoneName')}/>
                <div style={{marginTop: '12px'}}>
                    <label style={{fontSize: '13px', color: '#64748B', display: 'block', marginBottom: '4px'}}>
                        {t('gps.zones.maxOvertimeLabel')}
                    </label>
                    <input
                        type="number"
                        min="0"
                        value={createForm.max_overtime_minutes}
                        onChange={e => setCreateForm({...createForm, max_overtime_minutes: e.target.value})}
                        style={{width: '100%', padding: '8px', borderRadius: '6px', border: '1px solid #CBD5E1'}}
                    />
                </div>
            </Modal>

            <Modal show={showUploadModal} setter={setShowUploadModal} name={t('gps.zones.uploadZones')} buttonName={t('gps.zones.createZone')} onClick={saveUploadedZone}>
                {/* File input */}
                <div style={{marginBottom: '12px'}}>
                    <label style={{fontSize: '13px', color: '#64748B', display: 'block', marginBottom: '4px'}}>{t('gps.zones.upload.file')}</label>
                    <input type="file" accept=".csv,.txt,.xyz,.dat" onChange={handleFileSelect}
                           style={{width: '100%', padding: '6px', borderRadius: '6px', border: '1px solid #CBD5E1', fontSize: '13px'}}/>
                </div>

                {/* Delimiter */}
                <div style={{marginBottom: '12px'}}>
                    <label style={{fontSize: '13px', color: '#64748B', display: 'block', marginBottom: '4px'}}>{t('gps.zones.upload.delimiter')}</label>
                    <select value={uploadDelimiter} onChange={e => reparseFile(e.target.value)}
                            style={{width: '100%', padding: '8px', borderRadius: '6px', border: '1px solid #CBD5E1', fontSize: '13px'}}>
                        <option value="auto">{t('gps.zones.upload.autoDetect')}</option>
                        <option value="space">{t('gps.zones.upload.spaceWhitespace')}</option>
                        <option value="tab">{t('gps.zones.upload.tab')}</option>
                        <option value=",">{t('gps.zones.upload.comma')}</option>
                        <option value=";">{t('gps.zones.upload.semicolon')}</option>
                    </select>
                </div>

                {/* Preview table */}
                {uploadRows.length > 0 && (
                    <div style={{marginBottom: '12px', overflowX: 'auto'}}>
                        <label style={{fontSize: '13px', color: '#64748B', display: 'block', marginBottom: '4px'}}>
                            {t('gps.zones.upload.preview', {rows: uploadRows.length, cols: uploadRows[0]?.length})}
                        </label>
                        <table style={{width: '100%', fontSize: '11px', borderCollapse: 'collapse'}}>
                            <thead>
                                <tr>
                                    {uploadRows[0]?.map((_, i) => (
                                        <th key={i} style={{
                                            padding: '4px 6px', borderBottom: '1px solid #CBD5E1', textAlign: 'left',
                                            backgroundColor: i === uploadColX ? '#DBEAFE' : i === uploadColY ? '#D1FAE5' : '#F8FAFC',
                                        }}>
                                            {t('gps.zones.upload.col', {num: i + 1})}
                                            {i === uploadColX && ' (X)'}
                                            {i === uploadColY && ' (Y)'}
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {uploadRows.slice(0, 5).map((row, ri) => (
                                    <tr key={ri}>
                                        {row.map((val, ci) => (
                                            <td key={ci} style={{
                                                padding: '3px 6px', borderBottom: '1px solid #F1F5F9',
                                                backgroundColor: ci === uploadColX ? '#EFF6FF' : ci === uploadColY ? '#ECFDF5' : 'transparent',
                                            }}>{val}</td>
                                        ))}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}

                {/* Column mapping */}
                {uploadRows.length > 0 && (
                    <div className="d-flex gap-2" style={{marginBottom: '12px'}}>
                        <div style={{flex: 1}}>
                            <label style={{fontSize: '13px', color: '#3B82F6', display: 'block', marginBottom: '4px'}}>{t('gps.zones.upload.xCol')}</label>
                            <select value={uploadColX} onChange={e => setUploadColX(parseInt(e.target.value))}
                                    style={{width: '100%', padding: '8px', borderRadius: '6px', border: '1px solid #CBD5E1', fontSize: '13px'}}>
                                {uploadRows[0]?.map((_, i) => <option key={i} value={i}>{t('gps.zones.upload.column', {num: i + 1})}</option>)}
                            </select>
                        </div>
                        <div style={{flex: 1}}>
                            <label style={{fontSize: '13px', color: '#10B981', display: 'block', marginBottom: '4px'}}>{t('gps.zones.upload.yCol')}</label>
                            <select value={uploadColY} onChange={e => setUploadColY(parseInt(e.target.value))}
                                    style={{width: '100%', padding: '8px', borderRadius: '6px', border: '1px solid #CBD5E1', fontSize: '13px'}}>
                                {uploadRows[0]?.map((_, i) => <option key={i} value={i}>{t('gps.zones.upload.column', {num: i + 1})}</option>)}
                            </select>
                        </div>
                    </div>
                )}

                {/* Coordinate system */}
                <div style={{marginBottom: '12px'}}>
                    <label style={{fontSize: '13px', color: '#64748B', display: 'block', marginBottom: '4px'}}>{t('gps.zones.upload.coordSystem')}</label>
                    <select value={uploadCoordSystem} onChange={e => setUploadCoordSystem(e.target.value)}
                            style={{width: '100%', padding: '8px', borderRadius: '6px', border: '1px solid #CBD5E1', fontSize: '13px'}}>
                        <option value="wgs84">{t('gps.zones.upload.wgs84')}</option>
                        <option value="utm">{t('gps.zones.upload.utm')}</option>
                    </select>
                </div>

                {/* UTM options */}
                {uploadCoordSystem === 'utm' && (
                    <div className="d-flex gap-2" style={{marginBottom: '12px'}}>
                        <div style={{flex: 1}}>
                            <label style={{fontSize: '13px', color: '#64748B', display: 'block', marginBottom: '4px'}}>{t('gps.zones.upload.utmZone')}</label>
                            <input type="number" min="1" max="60" value={uploadUtmZone}
                                   onChange={e => setUploadUtmZone(Math.min(60, Math.max(1, parseInt(e.target.value) || 1)))}
                                   style={{width: '100%', padding: '8px', borderRadius: '6px', border: '1px solid #CBD5E1', fontSize: '13px'}}/>
                        </div>
                        <div style={{flex: 1}}>
                            <label style={{fontSize: '13px', color: '#64748B', display: 'block', marginBottom: '4px'}}>{t('gps.zones.upload.hemisphere')}</label>
                            <select value={uploadUtmHemi} onChange={e => setUploadUtmHemi(e.target.value)}
                                    style={{width: '100%', padding: '8px', borderRadius: '6px', border: '1px solid #CBD5E1', fontSize: '13px'}}>
                                <option value="N">{t('gps.zones.upload.north')}</option>
                                <option value="S">{t('gps.zones.upload.south')}</option>
                            </select>
                        </div>
                    </div>
                )}

                {/* Zone name */}
                <div style={{marginBottom: '12px'}}>
                    <label style={{fontSize: '13px', color: '#64748B', display: 'block', marginBottom: '4px'}}>{t('gps.zones.zoneName')}</label>
                    <input type="text" value={uploadZoneName} onChange={e => setUploadZoneName(e.target.value)}
                           placeholder={t('gps.zones.zoneName')}
                           style={{width: '100%', padding: '8px', borderRadius: '6px', border: '1px solid #CBD5E1', fontSize: '13px'}}/>
                </div>

                {/* Max overtime */}
                <div>
                    <label style={{fontSize: '13px', color: '#64748B', display: 'block', marginBottom: '4px'}}>
                        {t('gps.zones.maxOvertimeLabel')}
                    </label>
                    <input type="number" min="0" value={uploadMaxOvertime}
                           onChange={e => setUploadMaxOvertime(e.target.value)}
                           style={{width: '100%', padding: '8px', borderRadius: '6px', border: '1px solid #CBD5E1', fontSize: '13px'}}/>
                </div>
            </Modal>

            <Modal show={showEditModal} setter={setShowEditModal} name={t('gps.zones.editZone')} buttonName={t('common.save')} onClick={saveZoneEdit}>
                <TextInput form={editForm} setForm={setEditForm} name={'name'} placeholder={t('gps.zones.zoneName')}/>
                <div style={{marginTop: '12px'}}>
                    <label style={{fontSize: '13px', color: '#64748B', display: 'block', marginBottom: '4px'}}>
                        {t('gps.zones.maxOvertimeLabel')}
                    </label>
                    <input
                        type="number"
                        min="0"
                        value={editForm.max_overtime_minutes}
                        onChange={e => setEditForm({...editForm, max_overtime_minutes: e.target.value})}
                        style={{width: '100%', padding: '8px', borderRadius: '6px', border: '1px solid #CBD5E1'}}
                    />
                </div>
            </Modal>

            {/* SOS Save Confirm Modal */}
            <Modal show={sosSaveConfirmPending} setter={setSosSaveConfirmPending} name={t('gps.sos.confirmTitle')} buttonName={t('common.confirm')} onClick={() => saveSchedule(true)}>
                <div style={{padding: '4px 0'}}>
                    <p style={{fontSize: '13px', color: '#334155', marginBottom: '10px'}}>
                        {t('gps.sos.confirmMessage')}
                    </p>
                    <ul style={{margin: '0 0 10px 0', paddingLeft: '18px'}}>
                        {sosCoverage?.missing?.map(m => (
                            <li key={m.device_type_id || m.device_type_name} style={{fontSize: '13px', color: '#DC2626'}}>{m.device_type_name}</li>
                        ))}
                    </ul>
                    <p style={{fontSize: '12px', color: '#64748B', margin: 0}}>
                        {t('gps.sos.confirmContinue')}
                    </p>
                </div>
            </Modal>


            {/* Schedule Delete Confirm Modal */}
            <Modal show={showDeleteScheduleConfirm} setter={setShowDeleteScheduleConfirm} name={t('gps.zones.schedule.deleteSchedule')} buttonName={t('common.confirm')} onClick={confirmDeleteSchedule}>
                <p style={{margin: 0, fontSize: '14px'}}>{t('gps.zones.schedule.deleteConfirm')}</p>
            </Modal>

            {/* Schedule Error Modal: siempre visible si hay error, aunque el modal de schedule se cierre */}
            {scheduleError && (
                <Modal show={true} setter={() => setScheduleError(null)} name={t('common.error')} buttonName={t('common.confirm')} onClick={() => setScheduleError(null)} hideCancel>
                    <p style={{margin: 0, fontSize: '14px'}}>{scheduleError}</p>
                </Modal>
            )}

            {/* Schedule Modal */}
            <Modal show={showScheduleModal} setter={setShowScheduleModal}
                   name={schedulingZone?.schedule ? t('gps.zones.schedule.editSchedule') : t('gps.zones.schedule.newSchedule')}
                   buttonName={t('gps.zones.schedule.saveSchedule')} onClick={() => saveSchedule()}>
                <div style={{maxHeight: '65vh', overflowY: 'auto', paddingRight: '4px'}}>
                    {/* Schedule Type */}
                    <div style={{marginBottom: '12px'}}>
                        <label style={{fontSize: '13px', color: '#64748B', display: 'block', marginBottom: '4px'}}>{t('gps.zones.schedule.scheduleType')}</label>
                        <select value={scheduleForm.schedule_type} onChange={e => setScheduleForm({...scheduleForm, schedule_type: e.target.value})}
                                style={{width: '100%', padding: '8px', borderRadius: '6px', border: '1px solid #CBD5E1', fontSize: '13px'}}>
                            <option value="once">{t('gps.zones.schedule.once')}</option>
                            <option value="daily">{t('gps.zones.schedule.daily')}</option>
                            <option value="weekly">{t('gps.zones.schedule.weekly')}</option>
                        </select>
                    </div>

                    {/* Date for one-time */}
                    {scheduleForm.schedule_type === 'once' && (
                        <div style={{marginBottom: '12px'}}>
                            <label style={{fontSize: '13px', color: '#64748B', display: 'block', marginBottom: '4px'}}>{t('gps.zones.schedule.date')}</label>
                            <input type="date" value={scheduleForm.specific_date}
                                   onChange={e => setScheduleForm({...scheduleForm, specific_date: e.target.value})}
                                   style={{width: '100%', padding: '8px', borderRadius: '6px', border: `1px solid ${fieldErrors.specific_date ? '#EF4444' : '#CBD5E1'}`, fontSize: '13px'}}/>
                            {renderFieldError('specific_date')}
                        </div>
                    )}

                    {/* Days for weekly */}
                    {scheduleForm.schedule_type === 'weekly' && (
                        <div style={{marginBottom: '12px'}}>
                            <label style={{fontSize: '13px', color: '#64748B', display: 'block', marginBottom: '4px'}}>{t('gps.zones.schedule.days')}</label>
                            <div className="d-flex gap-1 flex-wrap">
                                {DAYS.map((d, i) => {
                                    const selected = scheduleForm.days_of_week.split(',').includes(String(i));
                                    return (
                                        <button key={i} onClick={() => {
                                            const current = scheduleForm.days_of_week.split(',').filter(x => x);
                                            const updated = selected ? current.filter(x => x !== String(i)) : [...current, String(i)];
                                            setScheduleForm({...scheduleForm, days_of_week: updated.join(',')});
                                        }} style={{
                                            padding: '4px 10px', borderRadius: '4px', fontSize: '12px', cursor: 'pointer',
                                            border: selected ? '1px solid #7C3AED' : '1px solid #CBD5E1',
                                            backgroundColor: selected ? '#7C3AED' : 'white', color: selected ? 'white' : '#334155',
                                        }}>{d}</button>
                                    );
                                })}
                            </div>
                        </div>
                    )}

                    {/* Start / End time */}
                    <div className="d-flex gap-2" style={{marginBottom: '12px'}}>
                        <div style={{flex: 1}}>
                            <label style={{fontSize: '13px', color: '#64748B', display: 'block', marginBottom: '4px'}}>{t('gps.zones.schedule.startTime')}</label>
                            <input type="time" value={scheduleForm.start_time}
                                   onChange={e => setScheduleForm({...scheduleForm, start_time: e.target.value})}
                                   style={{width: '100%', padding: '8px', borderRadius: '6px', border: `1px solid ${fieldErrors.start_time ? '#EF4444' : '#CBD5E1'}`, fontSize: '13px'}}/>
                            {renderFieldError('start_time')}
                        </div>
                        <div style={{flex: 1}}>
                            <label style={{fontSize: '13px', color: '#64748B', display: 'block', marginBottom: '4px'}}>{t('gps.zones.schedule.endTime')}</label>
                            <input type="time" value={scheduleForm.end_time}
                                   onChange={e => setScheduleForm({...scheduleForm, end_time: e.target.value})}
                                   style={{width: '100%', padding: '8px', borderRadius: '6px', border: `1px solid ${fieldErrors.end_time ? '#EF4444' : '#CBD5E1'}`, fontSize: '13px'}}/>
                            {renderFieldError('end_time')}
                        </div>
                    </div>

                    {/* Pre-alert section */}
                    <div style={{marginTop: '16px', paddingTop: '12px', borderTop: '1px solid #E2E8F0'}}>
                        <label className="d-flex align-items-center gap-2" style={{cursor: 'pointer', marginBottom: '8px'}}>
                            <input type="checkbox" checked={scheduleForm.pre_alert_enabled}
                                   onChange={e => setScheduleForm({...scheduleForm, pre_alert_enabled: e.target.checked})}/>
                            <span style={{fontSize: '14px', fontWeight: '600', color: '#334155'}}>{t('gps.zones.schedule.preAlert')}</span>
                        </label>

                        {scheduleForm.pre_alert_enabled && <>
                        <div style={{marginBottom: '10px'}}>
                            <label style={{fontSize: '13px', color: '#64748B', display: 'block', marginBottom: '4px'}}>{t('gps.zones.schedule.minutesBefore')}</label>
                            <input type="number" min="1" value={scheduleForm.pre_alert_minutes}
                                   onChange={e => setScheduleForm({...scheduleForm, pre_alert_minutes: parseInt(e.target.value) || 1})}
                                   style={{width: '100%', padding: '8px', borderRadius: '6px', border: '1px solid #CBD5E1', fontSize: '13px'}}/>
                        </div>

                        <div style={{marginBottom: '10px'}}>
                            <label style={{fontSize: '13px', color: '#64748B', display: 'block', marginBottom: '4px'}}>{t('gps.zones.schedule.actionType')}</label>
                            <select
                                value={scheduleForm.pre_alert_use_sos ? 'sos' : scheduleForm.pre_alert_action_type}
                                onChange={e => {
                                    if (e.target.value === 'sos') {
                                        setScheduleForm({...scheduleForm, pre_alert_use_sos: true});
                                        fetchSosCoverage(schedulingZone);
                                    } else {
                                        setScheduleForm({...scheduleForm, pre_alert_use_sos: false, pre_alert_action_type: parseInt(e.target.value)});
                                    }
                                }}
                                style={{width: '100%', padding: '8px', borderRadius: '6px', border: '1px solid #CBD5E1', fontSize: '13px'}}>
                                <option value={5}>MQTT</option>
                                <option value={6}>API</option>
                                <option value="sos">SOS</option>
                            </select>
                        </div>

                        {/* SOS coverage warning */}
                        {scheduleForm.pre_alert_use_sos && sosCoverage && sosCoverage.missing?.length > 0 && (
                            <div style={{marginBottom: '10px', padding: '8px 10px', backgroundColor: '#FEF9C3', border: '1px solid #FDE047', borderRadius: '6px', fontSize: '12px', color: '#713F12'}}>
                                <strong>⚠ {t('gps.zones.schedule.sosWarning')}</strong>{' '}
                                {sosCoverage.missing.map(m => m.device_type_name).join(', ')}
                            </div>
                        )}

                        {/* MQTT connection selector */}
                        {!scheduleForm.pre_alert_use_sos && scheduleForm.pre_alert_action_type === 5 && (
                            <div style={{marginBottom: '10px'}}>
                                <label style={{fontSize: '13px', color: '#64748B', display: 'block', marginBottom: '4px'}}>{t('gps.zones.schedule.mqttConnection')}</label>
                                <select value={scheduleForm.pre_alert_mqtt_connection}
                                        onChange={e => setScheduleForm({...scheduleForm, pre_alert_mqtt_connection: e.target.value})}
                                        style={{width: '100%', padding: '8px', borderRadius: '6px', border: '1px solid #CBD5E1', fontSize: '13px'}}>
                                    <option value="">{t('gps.zones.schedule.select')}</option>
                                    {mqttConnections.map(c => <option key={c.id} value={c.id}>{c.name || c.broker}</option>)}
                                </select>
                            </div>
                        )}

                        {/* API connection selector */}
                        {!scheduleForm.pre_alert_use_sos && scheduleForm.pre_alert_action_type === 6 && (
                            <>
                                <div style={{marginBottom: '10px'}}>
                                    <label style={{fontSize: '13px', color: '#64748B', display: 'block', marginBottom: '4px'}}>{t('gps.zones.schedule.apiConnection')}</label>
                                    <select value={scheduleForm.pre_alert_api_connection}
                                            onChange={e => setScheduleForm({...scheduleForm, pre_alert_api_connection: e.target.value})}
                                            style={{width: '100%', padding: '8px', borderRadius: '6px', border: '1px solid #CBD5E1', fontSize: '13px'}}>
                                        <option value="">{t('gps.zones.schedule.select')}</option>
                                        {apiConnections.map(c => <option key={c.id} value={c.id}>{c.name || c.base_url}</option>)}
                                    </select>
                                </div>
                                <div style={{marginBottom: '10px'}}>
                                    <label style={{fontSize: '13px', color: '#64748B', display: 'block', marginBottom: '4px'}}>{t('gps.zones.schedule.httpMethod')}</label>
                                    <select value={scheduleForm.pre_alert_http_method}
                                            onChange={e => setScheduleForm({...scheduleForm, pre_alert_http_method: e.target.value})}
                                            style={{width: '100%', padding: '8px', borderRadius: '6px', border: '1px solid #CBD5E1', fontSize: '13px'}}>
                                        <option value="GET">GET</option>
                                        <option value="POST">POST</option>
                                        <option value="PUT">PUT</option>
                                    </select>
                                </div>
                            </>
                        )}

                        {!scheduleForm.pre_alert_use_sos && <div style={{marginBottom: '10px'}}>
                            <label style={{fontSize: '13px', color: '#64748B', display: 'block', marginBottom: '4px'}}>
                                {scheduleForm.pre_alert_action_type === 5 ? t('gps.zones.schedule.topic') : t('gps.zones.schedule.endpoint')}
                            </label>
                            <PlaceholderInput
                                value={scheduleForm.pre_alert_topic_or_endpoint}
                                onChange={v => setScheduleForm({...scheduleForm, pre_alert_topic_or_endpoint: v})}
                                placeholder={scheduleForm.pre_alert_action_type === 5 ? 'alerts/prealert/{device_id}' : '/api/prealert/{device_id}'}
                                style={{width: '100%', padding: '8px', borderRadius: '6px', border: '1px solid #CBD5E1', fontSize: '13px'}}
                                placeholders={PRE_ALERT_PLACEHOLDERS}
                            />
                        </div>}

                        {!scheduleForm.pre_alert_use_sos && <div style={{marginBottom: '10px'}}>
                            <label style={{fontSize: '13px', color: '#64748B', display: 'block', marginBottom: '4px'}}>
                                {t('gps.zones.schedule.payload')}
                            </label>
                            <PlaceholderTextarea
                                value={scheduleForm.pre_alert_payload}
                                onChange={v => setScheduleForm({...scheduleForm, pre_alert_payload: v})}
                                rows={3}
                                style={{width: '100%', padding: '8px', borderRadius: '6px', border: '1px solid #CBD5E1', fontSize: '12px', fontFamily: 'monospace'}}
                                placeholders={PRE_ALERT_PLACEHOLDERS}
                            />
                        </div>}
                        </>}
                    </div>

                    {/* Targets section */}
                    <div style={{marginTop: '16px', paddingTop: '12px', borderTop: '1px solid #E2E8F0'}}>
                        <div style={{fontSize: '14px', fontWeight: '600', color: '#334155', marginBottom: '8px'}}>{t('gps.zones.schedule.targets')}</div>

                        <div className="d-flex gap-2" style={{marginBottom: '8px'}}>
                            <button onClick={() => { setSosCoverage(null); setScheduleTargets({...scheduleTargets, type: 'individuals'}); }}
                                    style={{padding: '4px 12px', borderRadius: '4px', fontSize: '12px', cursor: 'pointer',
                                        border: scheduleTargets.type === 'individuals' ? '1px solid #7C3AED' : '1px solid #CBD5E1',
                                        backgroundColor: scheduleTargets.type === 'individuals' ? '#7C3AED' : 'white',
                                        color: scheduleTargets.type === 'individuals' ? 'white' : '#334155'}}>
                                {t('gps.zones.schedule.individuals')}
                            </button>
                            <button onClick={() => { setSosCoverage(null); setScheduleTargets({...scheduleTargets, type: 'groups'}); }}
                                    style={{padding: '4px 12px', borderRadius: '4px', fontSize: '12px', cursor: 'pointer',
                                        border: scheduleTargets.type === 'groups' ? '1px solid #7C3AED' : '1px solid #CBD5E1',
                                        backgroundColor: scheduleTargets.type === 'groups' ? '#7C3AED' : 'white',
                                        color: scheduleTargets.type === 'groups' ? 'white' : '#334155'}}>
                                {t('gps.zones.schedule.groups')}
                            </button>
                        </div>

                        <div style={{maxHeight: '120px', overflowY: 'auto', border: '1px solid #E2E8F0', borderRadius: '6px', padding: '6px'}}>
                            {scheduleTargets.type === 'individuals' ? (
                                assets.map(a => (
                                    <label key={a.id} className="d-flex align-items-center gap-2" style={{fontSize: '13px', padding: '3px 0', cursor: 'pointer'}}>
                                        <input type="checkbox" checked={scheduleTargets.individual_ids.includes(a.id)}
                                               onChange={() => toggleTargetId(a.id, 'individual_ids')}/>
                                        {a.name}
                                    </label>
                                ))
                            ) : (
                                groups.map(g => (
                                    <label key={g.id} className="d-flex align-items-center gap-2" style={{fontSize: '13px', padding: '3px 0', cursor: 'pointer'}}>
                                        <input type="checkbox" checked={scheduleTargets.group_ids.includes(g.id)}
                                               onChange={() => toggleTargetId(g.id, 'group_ids')}/>
                                        {g.name}
                                    </label>
                                ))
                            )}
                        </div>
                    </div>

                    {/* Notification Methods */}
                    <div style={{marginTop: '16px', paddingTop: '12px', borderTop: '1px solid #E2E8F0'}}>
                        <div style={{fontSize: '14px', fontWeight: '600', color: '#334155', marginBottom: '10px'}}>{t('gps.zones.schedule.entryNotification')}</div>

                        {/* Method 1 */}
                        <div style={{
                            padding: '10px', border: '1px solid #E2E8F0', borderRadius: '6px',
                            marginBottom: '8px', backgroundColor: '#FAFAFA',
                        }}>
                            <div style={{fontSize: '12px', fontWeight: '600', color: '#64748B', marginBottom: '6px'}}>{t('gps.zones.schedule.method1')}</div>
                            <select
                                value={notificationConfig.method_1}
                                onChange={e => updateNotification('method_1', parseInt(e.target.value))}
                                style={{width: '100%', padding: '6px', borderRadius: '4px', border: '1px solid #CBD5E1', fontSize: '12px'}}>
                                {NOTIFICATION_METHODS.map(m => <option key={m.id} value={m.id}>{m.name}</option>)}
                            </select>
                            {renderMethodFields(1)}
                        </div>

                        {/* Method 2 (optional) */}
                        <div style={{
                            padding: '10px', border: '1px solid #E2E8F0', borderRadius: '6px',
                            backgroundColor: '#FAFAFA',
                        }}>
                            <div style={{fontSize: '12px', fontWeight: '600', color: '#64748B', marginBottom: '6px'}}>{t('gps.zones.schedule.method2Optional')}</div>
                            <select
                                value={notificationConfig.method_2 || ''}
                                onChange={e => updateNotification('method_2', e.target.value ? parseInt(e.target.value) : null)}
                                style={{width: '100%', padding: '6px', borderRadius: '4px', border: '1px solid #CBD5E1', fontSize: '12px'}}>
                                <option value="">{t('gps.zones.schedule.none')}</option>
                                {NOTIFICATION_METHODS
                                    .filter(m => m.id !== notificationConfig.method_1)
                                    .map(m => <option key={m.id} value={m.id}>{m.name}</option>)
                                }
                            </select>
                            {renderMethodFields(2)}
                        </div>

                        {/* SOS entry notification */}
                        <div style={{marginTop: '8px', padding: '10px', border: '1px solid #E2E8F0', borderRadius: '6px', backgroundColor: '#FAFAFA'}}>
                            <label className="d-flex align-items-center gap-2" style={{cursor: 'pointer', marginBottom: '0'}}>
                                <input type="checkbox"
                                       checked={scheduleForm.entry_notification_sos}
                                       onChange={e => {
                                           setScheduleForm({...scheduleForm, entry_notification_sos: e.target.checked});
                                           if (e.target.checked) fetchSosCoverage(schedulingZone);
                                       }}/>
                                <span style={{fontSize: '13px', fontWeight: '600', color: '#334155'}}>{t('gps.zones.schedule.sosEntry')}</span>
                            </label>
                            {scheduleForm.entry_notification_sos && sosCoverage && sosCoverage.missing?.length > 0 && (
                                <div style={{marginTop: '8px', padding: '8px 10px', backgroundColor: '#FEF9C3', border: '1px solid #FDE047', borderRadius: '6px', fontSize: '12px', color: '#713F12'}}>
                                    <strong>⚠ {t('gps.zones.schedule.sosWarning')}</strong>{' '}
                                    {sosCoverage.missing.map(m => m.device_type_name).join(', ')}
                                </div>
                            )}
                        </div>
                    </div>

                    {/* Delete schedule button */}
                    {schedulingZone?.schedule && (
                        <div style={{marginTop: '16px', paddingTop: '12px', borderTop: '1px solid #E2E8F0'}}>
                            <button onClick={deleteSchedule} style={{
                                width: '100%', padding: '8px', borderRadius: '6px', border: '1px solid #EF4444',
                                backgroundColor: 'white', color: '#EF4444', fontSize: '13px', cursor: 'pointer'
                            }}>{t('gps.zones.schedule.deleteSchedule')}</button>
                        </div>
                    )}
                </div>
            </Modal>

            <div className={styles.dashboardInnerContainer}>
                <PageTitle title={t('common.gpsTracking')}/>
                <GPSTabs active={2}/>

                {/* Drawing controls — above the map to avoid overlapping Google Maps UI */}
                <div style={{display: 'flex', gap: '8px', flexWrap: 'wrap', marginBottom: '8px'}}>
                    {!isDrawing ? (
                        <>
                        <button
                            onClick={startDrawing}
                            style={{
                                padding: '8px 16px', borderRadius: '6px', border: 'none',
                                backgroundColor: '#10B981', color: 'white', fontSize: '13px',
                                cursor: 'pointer', boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                                display: 'flex', alignItems: 'center', gap: '4px'
                            }}
                        >
                            <FontAwesomeIcon icon={faPencil} size="sm"/> {t('gps.zones.drawZone')}
                        </button>
                        <button
                            onClick={resetUploadModal}
                            style={{
                                padding: '8px 16px', borderRadius: '6px', border: 'none',
                                backgroundColor: '#3B82F6', color: 'white', fontSize: '13px',
                                cursor: 'pointer', boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                                display: 'flex', alignItems: 'center', gap: '4px'
                            }}
                        >
                            <FontAwesomeIcon icon={faUpload} size="sm"/> {t('gps.zones.uploadFile')}
                        </button>
                        </>
                    ) : (
                        <button
                            onClick={cancelDrawing}
                            style={{
                                padding: '8px 16px', borderRadius: '6px', border: 'none',
                                backgroundColor: '#EF4444', color: 'white', fontSize: '13px',
                                cursor: 'pointer', boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                            }}
                        >
                            {t('common.cancel')}
                        </button>
                    )}
                </div>

                <div className={gpsStyles.gpsLayout}>
                    {/* Map */}
                    <div className={gpsStyles.gpsMapWrapper}>
                        <GoogleMapReact
                            defaultCenter={mapCenter}
                            defaultZoom={mapZoom}
                            bootstrapURLKeys={{
                                key: 'AIzaSyAqEBaEszO4nf-OBb-VarsUZ_47bTwwc9g',
                                libraries: ['drawing']
                            }}
                            yesIWantToUseGoogleMapApiInternals
                            onGoogleApiLoaded={handleApiLoaded}
                            options={{mapTypeId: 'roadmap'}}
                        />
                    </div>

                    {/* Zone list */}
                    <div className={gpsStyles.gpsSidePanel}>
                        <h6 style={{fontWeight: '600', marginBottom: '12px'}}>{t('gps.zones.zonesCount', {count: zones.length})}</h6>
                        <div className="d-flex flex-column gap-2">
                            {zones.map(zone => (
                                <div key={zone.id} style={{
                                    padding: '12px',
                                    backgroundColor: 'white',
                                    borderRadius: '8px',
                                    border: '1px solid #E2E8F0',
                                }}>
                                    <div className="d-flex justify-content-between align-items-center">
                                        <div style={{fontWeight: '600', fontSize: '14px'}}>{zone.name}</div>
                                        <div className="d-flex gap-2">
                                            <FontAwesomeIcon
                                                icon={faClock}
                                                color={zone.schedule ? '#7C3AED' : '#94A3B8'}
                                                size="sm"
                                                style={{cursor: 'pointer'}}
                                                title={zone.schedule ? t('gps.zones.schedule.editTooltip') : t('gps.zones.schedule.addTooltip')}
                                                onClick={() => openScheduleModal(zone)}
                                            />
                                            <FontAwesomeIcon
                                                icon={faEdit}
                                                color="#64748B"
                                                size="sm"
                                                style={{cursor: 'pointer'}}
                                                onClick={() => editZone(zone)}
                                            />
                                            <FontAwesomeIcon
                                                icon={faTrash}
                                                color="#EF4444"
                                                size="sm"
                                                style={{cursor: 'pointer'}}
                                                onClick={() => deleteZone(zone.id)}
                                            />
                                        </div>
                                    </div>
                                    <div style={{fontSize: '12px', color: '#64748B', marginTop: '4px'}}>
                                        {zone.max_overtime_minutes ? t('gps.zones.maxOvertime', {minutes: zone.max_overtime_minutes}) : t('gps.zones.noLimit')}
                                    </div>
                                    {zone.schedule && (
                                        <div style={{fontSize: '11px', color: '#7C3AED', marginTop: '2px'}}>
                                            {t('gps.zones.schedule.scheduled', {start: zone.schedule.start_time?.substring(0,5), end: zone.schedule.end_time?.substring(0,5)})}
                                            {zone.schedule.schedule_type === 'once' && zone.schedule.specific_date && ` (${zone.schedule.specific_date})`}
                                            {zone.schedule.schedule_type === 'daily' && ` ${t('gps.zones.schedule.scheduledDaily')}`}
                                            {zone.schedule.schedule_type === 'weekly' && ` ${t('gps.zones.schedule.scheduledWeekly')}`}
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
